// src/components/dashboard/LogoutOverlay.jsx
import React from "react";
import LogoutButton from "../session/logout_container";

/**
 * Logout confirm overlay.
 */
const LogoutOverlay = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="dash-overlay" onClick={onClose}>
      <div className="dash-panel dash-logout-panel" onClick={(e) => e.stopPropagation()}>
        <h3 className="dash-logout-title">Sign out of COSMETINK ACADEMY?</h3>
        <p className="dash-logout-body">You can log back in anytime to pick up where you left off.</p>
        <div className="dash-logout-actions">
          <button type="button" className="dash-chip-button dash-chip-button-secondary" onClick={onClose}>
            Stay signed in
          </button>
          <LogoutButton />
        </div>
      </div>
    </div>
  );
};

export default LogoutOverlay;
